import './media.scss';

import React from 'react';

function Media({ className, include }) {
  const list = include || [
    'la-times',
    'forbes',
    'sf-weekly',
    'tech-crunch',
    'business-insider'
  ];

  return (
    <div
      className={
        'row center-xs middle-xs around-md' + (className ? ` ${className}` : '')
      }
    >
      {list.map(name => (
        <span key={name} className={`media-logo media-logo--${name}`} />
      ))}
    </div>
  );
}

export default Media;



// WEBPACK FOOTER //
// ./shared/components/home/landingPage/media.js